import { createAction, props } from '@ngrx/store';
import { ProductsResult } from '../../models';

export const EmptyGlobalSearch = createAction('[Search] Empty Global Search', props<{ searchQuery: string }>());

export const GlobalSearch = createAction('[Search] Global Search', props<{ searchQuery: string }>());
export const GlobalSearchSuccess = createAction('[Search] Global Search Success', props<{ products: any }>());
export const GlobalSearchFail = createAction('[Search] Global Search Fail', props<{ error: any }>());

export const LoadSearchResults = createAction('[Search] Load Search Results', props<{ searchQuery: string }>());
export const LoadSearchResultsSuccess = createAction(
  '[Search] Load Search Results Success',
  props<{ products: ProductsResult; loadMore?: boolean }>()
);
export const LoadSearchResultsFail = createAction('[Search] Load Search Results Fail', props<{ error: any }>());

export const LoadMoreSearchResults = createAction('[Search] Load More Search Results');
